import { Label } from "@/components/ui/label";
import moment from "moment";

const DatePicker = ({
	name,
	id,
	label = "ສະແດງຕາມວັນທີ",
	value,
	onChange,
	required = false,
	disabled = false,
	minDate,
	showLabel = true,
}: {
	name?: string;
	id?: string;
	value: string;
	onChange: (value: string) => void;
	label?: string | JSX.Element;
	required?: boolean;
	disabled?: boolean;
	minDate?: string;
	showLabel?: boolean;
}) => {
	return (
		<div className="flex flex-col gap-2">
			{showLabel ? (
				<Label htmlFor={id}>
					{label}
					{required && <span className="text-red-500">*</span>}
				</Label>
			) : null}
			<input
				name={name}
				id={id}
				type="date"
				value={value}
				onChange={(e) => onChange(e.target.value)}
				className="px-3 py-1.5 border rounded-md"
				required={required}
				disabled={disabled}
				min={
					minDate
						? moment(minDate).add(1, "day").format("YYYY-MM-DD")
						: undefined
				}
			/>
		</div>
	);
};

export default DatePicker;
